<template>
    <div class="bodyClass">
        <!--首页大框-->
        <div class="ph-top-box-ins">
            <mobileMenu />
            <!--菜单-->
            <!-- <div class="ph-logo-a4 mt10 pl10">
                <a href="#" class="dbi fl he40">
                    <img src="../../assets/mobile/images/logo2.png" width="" height="45" alt="" /></a>
                <a href="#" class="dbi fr he20 white pr10 mt14 mr12">
                    <span class="f14 txtsh">MENU</span>
                    <i class="fa fa-bars f18 txtsh"></i></a>
            </div> -->
            <!--菜单end-->
            <!-- <div class="ph-phone-mu" style="">
                <ul class="ph-ph-um-ul">
                    <li class="ph-ph-mu-li mt10"><a href="/mb/homeWebMb" class="db  f15 lp2 pl10 white txtsh">首页</a></li>
                    <li class="ph-ph-mu-li mt10"><a href="chanping-1.html" class="db white f15 lp2 pl10 txtsh">产品</a>
                        <div class="" style="">
                            <a class="db he34 ml50 ph-pml-a" href="chanping-4.html">视觉智能体</a>
                            <a class="db he34 ml50 ph-pml-a" href="chanping-3.html">新一代公共安全视觉智能体</a>
                            <a class="db he34 ml50 ph-pml-a" href="chanping-1.html">视觉大模型平台</a>
                            <a class="db he34 ml50 ph-pml-a" href="chanping-2.html">视觉大模型一体机</a>
                        </div>
                    </li>
                    <li class="ph-ph-mu-li mt10"><a href="jiejfa-1.html" class="db white txtsh f15 lp2 pl10">解决方案</a>
                        <div class="" style="">
                            <a class="db he34 ml50 ph-pml-a" href="jiejfa-1.html">公共安全行业解决方案</a>
                            <a class="db he34 ml50 ph-pml-a" href="yijii-2.html">应急行业解决方案</a>
                            <a class="db he34 ml50 ph-pml-a" href="chengguan-3.html">城管行业解决方案</a>
                            <a class="db he34 ml50 ph-pml-a" href="jiaotong-4.html">交通行业解决方案</a>
                            <a class="db he34 ml50 ph-pml-a" href="qiyuegl-5.html">企业管理解决方案</a>
                        </div>
                    </li>
                    <li class="ph-ph-mu-li mt10"><a href="severHtml.html" class="db white txtsh f15 lp2 pl10">服务&生态</a>
                    </li>
                    <li class="ph-ph-mu-li mt10"><a href="gywmHtml.html" class="db white txtsh f15 lp2 pl10">关于我们</a>
                    </li>
                </ul>
            </div> -->
            <!--背景图-->
            <!-- <div class="ph-top-backgr">
                <div class="ph-top-box-ins-img"
                    style="background:url(../../assets/mobile/images/bana-9.jpg) center center no-repeat;background-size:cover;">
                </div>
                <div class="ph-top-box-ins-imga1"
                    style="background:url(../../assets/mobile/images/z8-ytj.png) center center no-repeat;background-size:cover;">
                </div>
            </div> -->
             <div class="ph-top-backgr ">
                <div class="ph-top-box-ins-img img1"></div>
                <div class="ph-top-box-ins-imga1 img2"></div>
            </div>
            <!--背景图end-->

            <!--首页大框end-->
        </div>
        <!--首页大框-->
        <!--内容大框-->
        <div class="ph-main pt24">

            <!--解决方案-->
            <div class="w100 lh40 tc"> <span class="db f30 fb lp2 mt40">谛视万象多模态视觉大模型</span> <span
                    class="db f20  lp2 mt10 ph-col-gr">VisionMix Multimodal Vision Large Model</span> </div>
            <div class="w90 jz mt40 lh30 f16">
                <p class="tl mb40"><strong><span
                            style="color:rgb(255,0,0);">产品定位于</span></strong>视觉智能分析的基座平台，以视觉感知能力为核心，融合前沿科技，为公共安全、交通运输、城市管理、应急管理、水利、智能制造等各领域的视觉分析场景赋智。产品创新运用混合专家模式与思维链推理技术，高效连接智能感知设备，采集、对齐分析多模态数据，实时监测各领域视觉场景特征、行为和事件等。经深度神经网络与智能体决策多维解析，精准洞察潜在风险，满足用户多元高阶视觉分析需求，助力各行业智能化升级与跨越式发展。
                </p>
                <p class="f20 fb mb20 tc col-gr2">产品特性</p>
                <p class="f16 fb  tl" style="color:rgb(255,0,0);">杂场景算法零样本生成</p>
                <p class="tl">
                    产品打破了传统算法依赖大量样本训练的局限，凭借简洁的文字描述，即可快速完成精准的场景算法创建，通过多解析器与多提示词的支持，就能够在复杂场景中通过简单的条件叠加实现算法定制，无需深厚的技术背景即可满足业务需求，大大节省了时间与成本。无论是实时场景的快速调整，还是应对多变的业务需求，都能灵活应对，帮助用户在极短时间内实现精准的智能应用，在零样本数据的情况下，对新出现的目标或场景进行识别。
                </p>
                <p class="f16 fb mt20 tl" style="color:rgb(255,0,0);">识万物、辨场景、擅推理</p>
                <p class="tl">
                    产品不仅能够准确检测预定义类别目标，同时可依据自然语言描述实现开放域场景的智能适配。通过创新的深度学习架构，系统展现出强大的环境泛化能力和抗干扰特性，可有效解析包括未见类别在内的多样化视觉信息，为动态场景下的图像理解提供多维度智能分析能力。通过自主突破性技术架构有效解决了传统模型在应对新兴目标类别、复杂场景、复杂行为组合时的局限性，显著提升了跨领域视觉任务的执行效能。
                </p>
                <img src="../../assets/mobile/images/ying-25.jpg" width="95%" class="jz db" alt="" />
                <p class="f16 fb mt20 tl" style="color:rgb(255,0,0);">多模态语音文字交互</p>
                <p class="tl">
                    <b>全维度结构化：</b>将人、车、设备等万物全维度结构化，不仅可结构化基本特征还可识别行为、环境等内容，用户可根据自身需求完全自定义。
                </p>
                <p class="tl">
                    <b>语音文字式交互：</b>可采用文字对话方式进行交互检索，也可使用语音方式进行任务调度。维度可以是时间、地点、行为等多条件。
                </p>
                <p class="tl">
                    <b>数图应用融合：</b>系统支持实时与历史数据结构化查询两种模式，可根据需要自由切换。还可关联第三方数据进行数图融合应用。
                </p>
                <img src="../../assets/mobile/images/ying-26.jpg" width="95%" class="jz db" alt="" />
                <p class="f16 fb mt20 tl" style="color:rgb(255,0,0);">多模式场景应用</p>
                <p class="tl">
                    <b>实时布控预警：</b>通过兼容各类智能终端设备实时数据接入、根据不同应用场景灵活配置预警功能以及实现重点事件实时、准确的布控预警响应。
                </p>
                <p class="tl">
                    <b>多模态智能体应用：</b>通过自定义结构化，将人、车、设备等万物结构化，支持通过语音文字两种模式根据时间、地点等维度快速检索。
                </p>
                <p class="tl">
                    <b>智能终端应用：</b>与机器狗、机器人、智能门锁等带有摄像头的智能终端联通 ，赋能大模型分析能力 ，实现各类无人值守场景应用。
                </p>
                <p class="tl">
                    <b>视觉结构化应用：</b>对采集的视频、图像数据进行全面深入解析，构建结构化索引。可依据多维度信息快速定位相关视频、图像或文本数据。
                </p>
                <img src="../../assets/mobile/images/ying-27.jpg" width="95%" class="jz db" alt="" />
                <p class="f20 fb mb30 mt30 tc">产品优势</p>
                <p class="f16 fb  tl" style="color:rgb(255,0,0);">【分钟级算法创建、小时级部署上线、零样本训练、软硬一体化设计】</p>
                <p class="tl">分钟级算法创建，依托先进的自然语言处理和机器学习技术，用户仅需通过简洁文字描述，就能在分钟内完成复杂场景算法的定制。
                    小时级部署上线，高效一站式部署，从算法创建完成到上线使用，仅需小时级时间使新算法能迅速投入实际业务场景。
                    零样本训练，打破传统算法依赖大量样本训练的局限，在0样本数据的情况下，对新出现的目标或场景进行识别。
                    全国产化生态支持，完全适配自主可控的国产化IT底层架构和生态体系，全面支持华为鲲鹏+昇腾、海光+DCU等、飞腾国产化硬件技术路线；支持主流音视频标准化协议，如GB/T28181、GA/T1400、RTSP、ONVIF、FTP等。同时兼容海康威视、大华、宇视等主流设备厂商智能设备。
                </p>
                <p class="f20 fb mb30 mt30 tc">产品服务模式</p>
                <p class="tl">
                    云服务模式，依托高性能算力与先进AI技术，为中小企业及个人开发者提供开箱即用的视觉分析能力。通过与运营商深度合作，我们打造低门槛、高弹性的云化解决方案，支持图像识别、目标检测、生成式AI等多样化场景，用户无需复杂部署即可通过API快速调用。该服务采用按需付费模式，兼顾成本与效率，助力企业轻松实现智能化升级，让视觉AI能力触手可及。
                    能力矩阵服务模式，面对政府、大型企业客户，采用集群部署的方式提供视觉大模型智能底座，为其各项业务场景提供视觉分析能力支持。
                    一体机服务模式，在需要灵活部署或小规模视频接入的场景下，公司提供视觉大模型一体机。它是集成了前沿人工智能视觉大模型平台与高性能计算硬件的一站式智能设备，为用户提供开箱即用的视觉分析服务，无需复杂部署，助力各行业智能化升级与跨越式发展。
                </p>
                <p class="f20 fb  mt40 tc mb30">产品架构</p>
            </div>
            <!--解决方案end-->
            <!--产品-->
            <div class="ph-cpjg jz clearfloat ov">

                <div class="he229 p5"><img src="../../assets/mobile/images/y-b-13.jpg" width="100%" height="" alt="" />
                </div>
            </div>
            <!--产品end-->
        </div>
        <!--内容大框end-->
        <!--底宣-->

        <!--底宣end-->
        <!--底宣2-->
        <div class="ph-btto-b-a1 ov mt40">
            <div class="mt10 w95 jz pt10 pb10">
                <div class="tc"> <img src="../../assets/mobile/images/ying-28.jpg" width="76" height="76" alt="" class="dbi" /> </div>
                <ul class="w100 ov mt10">
                    <li class="tc">
                        <div class=" f16 white tc">上海谛视万象科技有限公司</div>
                        <div class="ov mt10 tc"><span class="dbi ph-btto-b-sp "><img src="../../assets/mobile/images/ico2_3.png" width="28" height="28" alt="" /></span><span class="dbi  ml10 mt4 f14 ph-col-gr3">联系电话：4007628008</span></div>
                    </li>
      
                </ul>
            </div>
        </div>
        <!--底宣2end-->
        <!--底宣3-->
        <div class="he90 tc ph-btto-c"><span class="db ph-col-gr3  pt18">辽ICP备2025061615号</span>
            <span class="db ph-col-gr3  mt10">Copyright © 2004 - 2025 谛视万象版权所有</span>
        </div>
        <!--底宣3end-->
    </div>
</template>
<script setup>
import mobileMenu from './mobile-menu.vue';
</script>
<style scoped>
@import '@/assets/mobile/css/default.css';
@import '@/assets/mobile/css/font-awesome.min.css';
@import '@/assets/mobile/css/margin.css';
@import '@/assets/mobile/css/main.css';

.img1 {
    background: url(../../assets/mobile/images/bana-9.jpg) center center no-repeat;
    background-size: cover;
}

.img2 {
    background: url(../../assets/mobile/images/z8-ytj.png) center center no-repeat;
    background-size:300%,100%,cover;
}
</style>